import { render, staticRenderFns } from "./Outros.vue?vue&type=template&id=1cf8eccb"
import script from "./Outros.vue?vue&type=script&lang=js"
export * from "./Outros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports